import { render, staticRenderFns } from "./EntityField.vue?vue&type=template&id=148b4fc6&scoped=true&"
import script from "./EntityField.vue?vue&type=script&lang=js&"
export * from "./EntityField.vue?vue&type=script&lang=js&"
import style0 from "./EntityField.vue?vue&type=style&index=0&id=148b4fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148b4fc6",
  null
  
)

export default component.exports